import axios from "redux/actions/instance";

export const addThreadAPI = (payload: any) => axios.post(`threads/`, payload);

export const patchThreadAPI = (id: number, payload: any) =>
  axios.patch(`threads/${id}/`, payload);

export const addMessageAPI = (payload: any) => axios.post(`messages/`, payload);
